import {
  GET_COMBO_CHDT,
  GET_COMBO_CHDT_SUCCESS,
  GET_COMBO_CHDT_FAILURE,
} from './actionTypes';

export const getComboCHDT = (dataSearch) => ({
  type: GET_COMBO_CHDT,
  dataSearch,
});

export const getComboCHDTSuccess = (data) => ({
  type: GET_COMBO_CHDT_SUCCESS,
  payload: data,
});

export const getComboCHDTFailure = () => ({
  type: GET_COMBO_CHDT_FAILURE,
});
